import { StringParam } from 'use-query-params';

export const queryParams = {
  gameRoundId: StringParam,
};
